import BaseHelpers from 'nast-helpers'

/**
 *
 */
export default class NastHelpers extends BaseHelpers {

}
